module.exports = __webpack_public_path__ + "static/media/undraw_not_found.1682d32b.svg";